export const chatIcon = "/resources/chat-icon.png";
export const doctorIcon = "/resources/doctor-icon.png";
export const reportIcon = "/resources/report-icon.png";
